var map = {
	"./american-bittern/american-bittern-1.mp3": "1b49",
	"./american-bittern/american-bittern-2.mp3": "c1da",
	"./american-coot/american-coot-1.mp3": "eff2",
	"./american-coot/american-coot-2.mp3": "77f9",
	"./american-kestrel/american-kestrel-1.mp3": "1318",
	"./american-kestrel/american-kestrel-2.mp3": "0c46",
	"./american-robin/american-robin-1.mp3": "6dcf",
	"./american-robin/american-robin-2.mp3": "360e",
	"./american-robin/american-robin-3.mp3": "b080",
	"./belted-kingfisher/belted-kingfisher-1.mp3": "ca1b",
	"./belted-kingfisher/belted-kingfisher-2.mp3": "06ea",
	"./cameraShutter.mp3": "277c",
	"./canada-goose/canada-goose-1.mp3": "d994",
	"./canada-goose/canada-goose-2.mp3": "c02a",
	"./common-loon/common-loon-1.mp3": "c62c",
	"./common-loon/common-loon-2.mp3": "3cc5",
	"./common-loon/common-loon-3.mp3": "e7fc",
	"./eastern-wood-pewee/eastern-wood-pewee-1.mp3": "46df",
	"./eastern-wood-pewee/eastern-wood-pewee-2.mp3": "b25f",
	"./mourning-dove/mourning-dove-1.mp3": "9b64",
	"./mourning-dove/mourning-dove-2.mp3": "9d41",
	"./mourning-dove/mourning-dove-3.mp3": "0a3e",
	"./osprey/western-osprey-1.mp3": "70ff",
	"./osprey/western-osprey-2.mp3": "a10d",
	"./osprey/western-osprey-3.mp3": "03bf",
	"./pied-billed-grebe/pied-billed-grebe-1.mp3": "12c6",
	"./pied-billed-grebe/pied-billed-grebe-2.mp3": "3b1c",
	"./pied-billed-grebe/pied-billed-grebe-3.mp3": "2984",
	"./purple-finch/purple-finch-1.mp3": "94e5",
	"./purple-finch/purple-finch-2.mp3": "0c00",
	"./purple-finch/purple-finch-3.mp3": "367f",
	"./red-tailed-hawk/red-tailed-hawk-1.mp3": "6511",
	"./red-tailed-hawk/red-tailed-hawk-2.mp3": "4723",
	"./red-tailed-hawk/red-tailed-hawk-3.mp3": "0519",
	"./red-winged-blackbird/red-winged-blackbird-1.mp3": "67bf",
	"./red-winged-blackbird/red-winged-blackbird-2.mp3": "da13",
	"./red-winged-blackbird/red-winged-blackbird-3.mp3": "f298",
	"./ring-billed-gull/ring-billed-gull-1.mp3": "55f4",
	"./ring-billed-gull/ring-billed-gull-2.mp3": "e327",
	"./ring-billed-gull/ring-billed-gull-3.mp3": "84ea",
	"./song-sparrow/song-sparrow-1.mp3": "c61e",
	"./song-sparrow/song-sparrow-2.mp3": "5f21",
	"./song-sparrow/song-sparrow-3.mp3": "8ba4",
	"./swainsons-thrush/swainsons-thrush-1.mp3": "6ee6",
	"./swainsons-thrush/swainsons-thrush-2.mp3": "3aa0",
	"./swainsons-thrush/swainsons-thrush-3.mp3": "48b7",
	"./warbling-vireo/warbling-vireo-1.mp3": "bb15",
	"./warbling-vireo/warbling-vireo-2.mp3": "69d5",
	"./warbling-vireo/warbling-vireo-3.mp3": "8b4a",
	"./western-wood-pewee/western-wood-pewee-1.mp3": "d95d",
	"./western-wood-pewee/western-wood-pewee-2.mp3": "e8d5",
	"./western-wood-pewee/western-wood-pewee-3.mp3": "2010",
	"./wood-duck/wood-duck-1.mp3": "c7e7",
	"./wood-duck/wood-duck-2.mp3": "42e8",
	"./wood-duck/wood-duck-3.mp3": "68d1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5fa7";